module.exports = __webpack_public_path__ + "static/media/LoginBackground.05608f99.jpg";